import { AbstractControl, FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { Delivery } from './delivery.schema';
import { Product } from './product.schema';
import { phoneValid } from '../helpers/validators/phone.validator';
import { EnumAux } from '../helpers/enum-aux.helper';

export enum CustomSalePaymentStatus {
    paid = "paid",
    toBePaid = "toBePaid",
}

export class CustomSalePaymentStatusAux extends EnumAux {
    static active = ["toBePaid"];
    static inactive = ["paid"];
    static mixed = ["toBePaid", "paid"];

    static aux = {
        paid: { css: "red", ln: { it: "Pagata" } },
        toBePaid: { css: "yellow", ln: { it: "essere pagato" } },
    }
}

export enum CustomSaleFulFillmentStatus {
    fullfilled = "fullfilled",
    unfullfilled = "unfullfilled",
}

export class CustomSaleFulFillmentStatusAux extends EnumAux {
    static active = ["unfullfilled"];
    static inactive = ["fullfilled"];
    static mixed = ["unfullfilled", "fullfilled"];

    static aux = {
        fullfilled: { css: "red", ln: { it: "Soddisfatto" } },
        unfullfilled: { css: "yellow", ln: { it: "insoddisfatta" } },
    }
}

export class CustomSale {
    public static validation(profile = false): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            orderId: new FormControl(''),
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required),
            channel: new FormControl(''),
            total: new FormControl(''),
            paymentStatus: new FormControl(''),
            fullFillmentStatus: new FormControl(''),
            deliveryMethod: new FormControl(''),
            address: new FormControl('', Validators.required),
            phone: new FormControl('', phoneValid()),
            deliveryDate: new FormControl('', Validators.required),
            vendor: new FormControl(''),
            // partner: new FormGroup({ name: new FormControl('') }),
            status: new FormControl(''),
            notes: new FormControl(''),
            intercom: new FormControl('', Validators.required),
            deliveryTime: new FormControl('', [Validators.required]),
            deliveryProducts: new FormArray([new FormGroup(DeliveryProduct.validation())]),
            senderSurname: new FormControl(''),
            senderName: new FormControl(''),
            senderPhone: new FormControl('', phoneValid()),
            ddtFile: new FormControl(undefined),
            ddtNumber: new FormControl(''),
            smsPhoneNo: new FormControl('', phoneValid()),
            totalShippingAmount: new FormControl('', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
            totalPrice: new FormControl('', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
            totalLineItemsPrice: new FormControl('', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
            longitude: new FormControl(''),
            latitude: new FormControl(''),
            province: new FormControl(''),
            customSalePaymentStatus: new FormControl(CustomSalePaymentStatus.toBePaid),
            customSaleFulfillmentStatus: new FormControl(CustomSaleFulFillmentStatus.unfullfilled),
            isFlexiblePrice: new FormControl(false),
            flexiblePrice: new FormControl(''),
            isFlexbleDeliveryTime: new FormControl(false),
            existingCustomer:new FormControl(false),
            customer: new FormControl(''),
            receiverEmail: new FormControl('', Validators.compose([Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])),
            greetingNote: new FormControl(''),
            platform: new FormControl('', Validators.required),
        };
        return validator;
    }

    public static productFormGroup() {
        return new FormGroup(DeliveryProduct.validation());
    }

    public static readonly validationMessages = {
        'firstName': [{ type: 'required', message: 'Obbligatorio' }],
        'lastName': [{ type: 'required', message: 'Obbligatorio' }],
        'address': [{ type: 'required', message: 'Obbligatorio' }],
        'deliveryTime': [{ type: 'required', message: 'Obbligatorio' }],
        'intercom': [{ type: 'required', message: 'Obbligatorio' }],
        'receiverPhone': [{ type: 'phone', message: 'Formato invalido. Deve contenere fra le 10 e le 14 cifre' }],
        'senderPhone': [{ type: 'phone', message: 'Formato invalido. Deve contenere fra le 10 e le 14 cifre' }],
        'phone': [{ type: 'phone', message: 'Formato invalido. Deve contenere fra le 10 e le 14 cifre' }],
        'smsPhoneNo': [{ type: 'phone', message: 'Formato invalido. Deve contenere fra le 10 e le 14 cifre' }],
        'deliveryDate': [
            { type: 'required', message: 'Obbligatoria' },
            { type: 'moreThan', message: 'Non può essere nel passato' }
        ],
        'deliveryProducts': {
            'product': {
                'id': [
                    { type: 'required', message: 'Obbligatorio' }
                ],
                'quantity': [
                    { type: 'required', message: 'Obbligatorio' },
                    { type: 'pattern', message: 'La quantità deve essere un numero intero positivo' }
                ],
                'productPrice': [
                    { type: 'required', message: 'Obbligatorio' },
                    { type: 'pattern', message: 'Il prezzo deve essere un numero valido (max 2 decimali)' }
                ],
                'productPublicPrice': [
                    { type: 'required', message: 'Obbligatorio' },
                    { type: 'pattern', message: 'Il prezzo pubblico deve essere un numero valido (max 2 decimali)' }
                ],
                'partner': [
                    { type: 'required', message: 'Obbligatorio' }
                ],
                'productImage': [
                    { type: 'fileType', message: 'Formati accettati: png, jpg, gif, jpeg' },
                ],
            },
        },
        'partner': {
            'id': [{ type: 'required', message: 'Obbligatorio' }]
        },
        'totalShippingAmount': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'pattern', message: 'Deve essere un numero valido' }
        ],
        'longitude': [{ type: 'required', message: 'Obbligatorio' }],
        'latitude': [{ type: 'required', message: 'Obbligatorio' }],
        'province': [{ type: 'required', message: 'Obbligatorio' }],
        'totalPrice': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'pattern', message: 'Deve essere un numero valido' }
        ],
        'totalLineItemsPrice': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'pattern', message: 'Deve essere un numero valido' }
        ],
        'flexiblePrice': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'pattern', message: 'Deve essere un numero valido' }
        ],
        'customer': [{ type: 'required', message: 'Obbligatorio' }],
        'receiverEmail': [
            { type: 'required', message: 'Obbligatoria' }, 
            { type: 'pattern', message: 'Formato errato' }
        ],
        'platform': [{ type: 'required', message: 'Obbligatorio' }],
    };

    constructor(
        public id?: number,
        public orderId?: number,
        public firstName?: string,
        public lastName?: string,
        public channel?: string,
        public paymentStatus?: string,
        public fullFillmentStatus?: string,
        public deliveryMethod?: string,
        public address?: string,
        public phone?: string,
        public vendor?: string,
        public status?: string,
        public fromTime?: string,
        public toTime?: string,
        public notes?: string,
        public intercom?: string,
        public deliveryProducts?: DeliveryProduct[],
        public senderSurname?: string,
        public senderName?: string,
        public ddtFile?: string,
        public ddtNumber?: string,
        public currentTotalPriceSet?: any,
        public currentTotalTax?: any,
        public currentTotalTaxSet?: any,
        public subTotalPrice?: any,
        public subTotalPriceSet?: any,
        public totalDiscounts?: any,
        public totalDiscountsSet?: any,
        public totalLineItemsPrice?: any,
        public totalLineItemsPriceSet?: any,
        public totalPrice?: any,
        public totalPriceSet?: any,
        public totalShippingPriceSet?: any,
        public totalTax?: any,
        public totalTaxSet?: any,
        public refunds?: any,
        public shippingLines?: any,
        public totalShippingAmount?: any,
        public customSalePaymentStatus?: CustomSalePaymentStatus,
        public customSaleFulfillmentStatus?: CustomSaleFulFillmentStatus,
        public customSalePaymentLink?: string,
        public customSaleLineItems?: string,
        public deliveryTime?: string,
        public deliveryDate?: Date,
        public flexiblePrice?: string,
        public isFlexiblePrice?: boolean,
        public isFlexbleDeliveryTime?: boolean,
        public existingCustomer?: boolean,
        public customer?: any,
        public receiverEmail?: any,
        public deliveries?: any,
        public note?: string,
        public greetingNote?: string,
        public customSale?: boolean,
        public platform?: string,
    ) { }
}

export class DeliveryProduct {
    public static validation(): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            product: this.productFormGroup(),
            productVariant: new FormControl(null),
        };
        return validator;
    }

    public static productFormGroup() {
        return new FormGroup({
            id: new FormControl('', Validators.required),
            quantity: new FormControl('1', [Validators.required,  Validators.pattern(/^[1-9]\d*$/)]),
            productPrice: new FormControl(null, [
                Validators.required,
                Validators.pattern(/^\d+(\.\d{1,2})?$/)
            ]),
            productPublicPrice: new FormControl(null, [
                Validators.required,
                Validators.pattern(/^\d+(\.\d{1,2})?$/)
            ]),
            productNote: new FormControl('', [

            ]),
            hiddenProduct: new FormControl(false),
            productImage: new FormControl(undefined),
            partner: new FormControl(null, Validators.required)
            //name: new FormControl('', Validators.required),
            //sku: new FormControl(''),
            //price: new FormControl(''),
        });
    }

    constructor(
        public delivery?: Delivery,
        public product?: Product,
        public date?: Date,
        public quantity?: number,
        public price?: number,
        public productVariant?: any,
        public updatedAt?: Date,
        public createdAt?: Date,
    ) { }
}